/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { CommonPageData } from '../../styles/common.style';
import { getNotifications, markAsRead } from "../../actions/user_program";
import { connect } from "react-redux";


const Notification = ({ getNotifications, notificationList: reduxNotificationList, markAsRead }) => {
    let navigate = useNavigate();
    const [hasFetched, setHasFetched] = useState(false);
    // Local state to manage changes after marking as read
    const [notificationList, setNotificationList] = useState([]);
    let user = localStorage.getItem("user");
    user = user ? JSON.parse(user) : null;

    useEffect(() => {
        if (!hasFetched) {
            if (user) {
                getNotifications();
            }
            setHasFetched(true);
        }
    }, [hasFetched]);

    useEffect(() => {
        if (reduxNotificationList) {
            setNotificationList(reduxNotificationList.data); // update local state
        }
    }, [reduxNotificationList]);

    const handleNotificationClick = (url) => {
        navigate(url);
    };

    const handleMarkAsRead = async (notificationId) => {
        try {
            await markAsRead(notificationId); // call API to mark as read
            setNotificationList((prev) => prev.filter(n => n.id !== notificationId)); // remove from list
        } catch (error) {
            console.error("Error marking notification as read", error);
        }
    };

    return (
        <>
            <Header />
            <CommonPageData>
                {/* <div className='common-banner-block'>
              <div className='main-banner'>
                <img src='/images/banner-common-block.png' alt='img' />
              </div>
              <div className='container'>
                <div className='common-banner-block-inner'>
                  <h1>Notifications</h1>
                </div>
              </div>
            </div> */}
                <section className='assestmentd1_001 notifacation-text program-box-height common-padding-block'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 col-lg-12 col-md-12'>
                                <h2 className='title-inner-block  text-center'>Notifications</h2>
                                <>
                                    <div className="mt-4">
                                        {notificationList?.length === 0 ? (
                                            <div className="text-center text-muted">
                                                You have no notifications.
                                            </div>
                                        ) : (
                                            <ul className="">
                                                {notificationList?.map((notification, index) => (
                                                    <>
                                                        <li
                                                            className="notification-item"
                                                            key={index}

                                                        >
                                                            <div onClick={() => handleNotificationClick(notification.url)}>
                                                                <h4>{notification.title}</h4>
                                                                <p>{notification.body}</p>
                                                            </div>

                                                            <button
                                                                className="btn btn-sm btn-danger mt-3"
                                                                onClick={() => handleMarkAsRead(notification.id)}
                                                            >
                                                                Mark as Read
                                                            </button>
                                                        </li>

                                                    </>
                                                ))}
                                            </ul>
                                        )}
                                    </div>

                                </>
                            </div>
                        </div>
                    </div>
                </section>
            </CommonPageData>
            <Footer />
        </>
    );
}

Header.propTypes = {};

const mapStateToProps = (state) => ({
    notificationList: state.programReducer.notificationList,
});
export default connect(mapStateToProps, { getNotifications, markAsRead })(
    Notification
);